import api from './api';

class UserService {
  // User Profile
  async getUserProfile() {
    try {
      const response = await api.request('/user/profile/');
      return response;
    } catch (error) {
      throw error;
    }
  }

  async updateUserProfile(profileData) {
    try {
      const response = await api.request('/user/profile/update/', {
        method: 'PUT',
        body: JSON.stringify(profileData)
      });
      return response;
    } catch (error) {
      throw error;
    }
  }

  async changePassword(currentPassword, newPassword) {
    try {
      const response = await api.request('/user/change-password/', {
        method: 'POST',
        body: JSON.stringify({
          current_password: currentPassword,
          new_password: newPassword
        })
      });
      return response;
    } catch (error) {
      throw error;
    }
  }

  // User Dashboard
  async getUserDashboard() {
    try {
      const response = await api.request('/user/dashboard/');
      return response;
    } catch (error) {
      throw error;
    }
  }

  // Document Services (placeholder for future implementation)
  async uploadDocument(documentData) {
    try {
      const response = await api.request('/documents/upload/', {
        method: 'POST',
        body: JSON.stringify(documentData)
      });
      return response;
    } catch (error) {
      throw error;
    }
  }

  async getDocuments() {
    try {
      const response = await api.request('/documents/');
      return response;
    } catch (error) {
      throw error;
    }
  }

  // Tax Services (placeholder for future implementation)
  async getTaxServices() {
    try {
      const response = await api.request('/tax-services/');
      return response;
    } catch (error) {
      throw error;
    }
  }

  async requestTaxService(serviceData) {
    try {
      const response = await api.request('/tax-services/request/', {
        method: 'POST',
        body: JSON.stringify(serviceData)
      });
      return response;
    } catch (error) {
      throw error;
    }
  }
}

export default new UserService();
